// extracted by mini-css-extract-plugin
export default {"label":"SettingsSwitchItem_label__s0Q-E","root":"SettingsSwitchItem_root__McpH4"};